/**
 * 播放
 */
const PayIcon = ({ width = 96, height = 96 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        width="96"
        height="96"
        rx="48"
        transform="matrix(1 0 0 -1 0 96.001)"
        fill="black"
        fillOpacity="0.4"
      />
      <path
        d="M66.0981 48.328C66.3244 48.1687 66.3244 47.8333 66.0981 47.6739L38.7934 28.4448C38.5284 28.2582 38.1631 28.4478 38.1631 28.7719L38.1631 67.23C38.1631 67.5542 38.5284 67.7437 38.7934 67.5571L66.0981 48.328Z"
        fill="white"
      />
    </svg>
  )
}

export default PayIcon
